import { defineMessages } from 'react-intl-next';
// NAV 4 CHANGEBOARDING
export const globalSpotlight = defineMessages({
	heading: {
		id: 'modernize-changeboarding.nav4-global-spotlight.heading',
		defaultMessage: 'Find everything you need in the sidebar',
		description:
			'Title of onboarding message describing the new global navigation menu at the top of the sidebar.',
	},
	body: {
		id: 'modernize-changeboarding.nav4-global-spotlight.body',
		defaultMessage:
			'Parts of the navigation have moved to the sidebar, which you can customize to your unique needs. ',
		description:
			'Body of a tutorial message describing the new global navigation menu at the top of the sidebar.',
	},
});
export const collapseSpotlight = defineMessages({
	heading: {
		id: 'modernize-changeboarding.nav4-collapse-spotlight.heading',
		defaultMessage: 'Show or hide the sidebar',
		description: 'Title of onboarding message describing the new sidebar collapse button',
	},
	body: {
		id: 'modernize-changeboarding.nav4-collapse-spotlight.body',
		defaultMessage: 'Select this icon to expand or collapse the sidebar.',
		description: 'Body of a tutorial message describing the new sidebar collapse button',
	},
});
export const spaceSettingsSpotlight = defineMessages({
	heading: {
		id: 'modernize-changeboarding.nav4-space-settings-spotlight.heading',
		defaultMessage: 'Quick access to settings and more',
		description: 'Title of onboarding message describing how to locate space settings',
	},
	body: {
		id: 'modernize-changeboarding.nav4-space-settings-spotlight.body',
		defaultMessage:
			'Find <strong>Space settings</strong> in <strong>More actions</strong> (<strong>•••</strong>), where you can manage permissions, access, and content, and access Premium features.',
		description: 'Body of a tutorial message describing how to locate space settings',
	},
});

// CONTENT WRAPPER CHANGEBOARDING
export const floatingMenuSpotlight = defineMessages({
	heading: {
		id: 'modernize-changeboarding.floating-menu-spotlight.heading',
		defaultMessage: 'Comments, details, and more',
		description: 'Title of tutorial message describing the floating menu functionality',
	},
	body: {
		id: 'modernize-changeboarding.floating-menu-spotlight.body',
		defaultMessage: 'Work faster with a <a>floating menu</a> that gets you closer to your content.',
		description: 'Body of a tutorial message describing the floating menu functionality',
	},
});

export const lastUpdatedSpotlight = defineMessages({
	heading: {
		id: 'modernize-changeboarding.last-updated-spotlight.heading',
		defaultMessage: 'Last updated is here',
		description: 'Title of tutorial message describing the last updated functionality',
	},
	body: {
		id: 'modernize-changeboarding.last-updated-spotlight.body',
		defaultMessage: 'Instantly track when your content was <a>last updated</a>.',
		description: 'Body of a tutorial message describing the last updated functionality',
	},
});

// LIVE DOCS CHANGEBOARDING
export const convertToPageSpotlight = defineMessages({
	heading: {
		id: 'modernize-changeboarding.convert-to-page-spotlight.heading',
		defaultMessage: 'Convert any live doc to a page',
		description: 'Title of tutorial message describing the convert to page functionality',
	},
	body: {
		id: 'modernize-changeboarding.convert-to-page-spotlight.body',
		defaultMessage:
			'<a>Live docs</a> can be converted and published as pages (and converted back) anytime.',
		description: 'Body of a tutorial message describing the convert to page menu item',
	},
});
